<!--
	功能：该组件用于实现复选框的相关显示及控制
	可提供如下功能, 支持的形态及功能有:
		1.  复选框的大小设置(size)
		2.  复选框的值设置(val)
		3.  复选框的边框颜色设置(bdrClr)
		4.  复选框的选中勾的颜色设置(hookClr)
		5.  复选框的使能设置(disabled)
		6.  复选框的默认选中状态设置(checked)
		7.  复选框的提示文字(capt)
		8.  复选框的自定义事件响应(myClick)
		9.  获取同一分组选中复选框的值列表(getCheckValuesByName)
		10. 禁用/启用指定的复选框(setDisabled)
		11. 选中/取消选中指定的复选框(setChecked)
	组件调用参数:
		参数名        必要性   值域        说明
		grpName       必须     string      复选框所属的分组名称, 分组的组件, 可以使用 getCheckValuesByName 方法获取该组所有选中组件的值列表
		size          必须     int         复选框的复选框的大小(组件可见边框将会比该size小2个像素, 确保与周围组件至少有1个像素可见间隙)
		val           必须     string      复选框的值
		bdrClr        可选     #xxxxxx     复选框的可见边框的颜色
		hookClr       可选     #xxxxxx     复选框的选中勾的颜色
		checked       可选     bool        复选框的默认选中状态
		disabled      可选     bool        复选框的使能状态
		capt          可选     string      复选框的提示文字
		myClick       可选     function    复选框的点击响应事件, 事件参数为( newValue, oldValue )
	输出的值:
		$emit("input")    可用 v-model 接收参数值
	外部调用方法:
		setDisabled: function( flag )    //禁用或启用组件, true-禁用, false-启用
		setChecked: function( flag )     //设置组件的选中状态, true-选中, false-不选中, 会更新v-model指定的变量, 但是不调用 myClick 指定的事件
	Vue方法:
		getCheckValuesByName( pGrpName )   //获取指定分组名的选中组件的值列表
-->

<template>
	<div id="idCheckPanel" ref="idCheckPanel">
		<div id="idChkBdr" ref="idChkBdr" @click="onCheckClick">
			<div id="idChkHook" ref="idChkHook"></div>
		</div>
		<div id="idChkCapt" ref="idChkCapt">{{capt}}</div>
		<input id="idChkHide" ref="idChkHide" type="checkbox" :name="grpName" :value="val" style="display:none;">
	</div>
</template>

<script>

import Vue from 'vue'

/* 获取 CCheck 组件指定分组的选中值 */
/* pName: 需要取值的 CCheck 组件的分组名称 */
Vue.prototype.getCheckValuesByName=function( pName ){
	let v="";
	let obj=document.getElementsByName( pName );
	for( let i=0; i<obj.length; i++ )
	{
		if( obj[i].checked )
		{
			if( v!="" ) v = v + ",";
			v = v + obj[i].getAttribute("value");
		}
	}
	return v;
}

export default {
	name: 'CCheckBox',
	props:['size', 'bdrClr', 'hookClr', 'val', 'checked', 'disabled', 'myClick', 'capt', 'grpName'],
	data () {
		return {
			w:  this.size,                 //组件的尺寸
			w1: this.size-2,               //可见边框的尺寸
			w2: this.size-4,               //选中的勾的尺寸
			w3: this.size-8,               //选中的勾的字体大小
			myBdrClr: "",                  //组件当前的边框颜色
			myHookClr: "",                 //组件当前的选中的勾颜色
			myDisabled: this.disabled,     //组件当前的使能状态
			myChecked: false,              //组件当前的选中状态
			myVal: "",                     //组件当前的值
		}
	},
	mounted: function(){
		let bdr=this.$refs["idChkBdr"];
		bdr.style["width"]  = (this.w1)+"px";
		bdr.style["height"] = (this.w1)+"px";

		let hook=this.$refs["idChkHook"];
		hook.style["width"]  = (this.w2)+"px";
		hook.style["height"] = (this.w2)+"px";
		hook.style["line-height"] = (this.w2)+"px";
		hook.style["font-size"]   = (this.w3)+"px";

		let capt=this.$refs["idChkCapt"];

		if( !this.disabled ) this.myDisabled = false;

		this.myChecked = this.checked;
		if( this.myChecked )   //处理默认选中状态
		{
			this.$refs["idChkHide"].checked = true;
			hook.innerText = "√";
			this.myVal = this.val;
			this.$emit("input", this.myVal );
		}
		if( this.myDisabled )    //如果是禁用的
		{
			bdr.style["border"] = "1px solid #b4b4b4";
			hook.style["color"] = "#b4b4b4";
			this.myBdrClr  = "#b4b4b4";
			this.myHookClr = "#b4b4b4";
			capt.style["color"] = "#b4b4b4";
		}
		else   //正常可用状态
		{
			if( this.bdrClr  )
			{
				bdr.style["border"] = "1px solid "+this.bdrClr;
				this.myBdrClr = this.bdrClr;
			}
			else
			{
				this.myBdrClr = "#4a4a4a";
			}

			if( this.hookClr )
			{
				hook.style["color"] = this.hookClr;
				this.myHookClr = this.hookClr;
			}
			else
			{
				this.myHookClr = "#4a4a4a";
			}
		}
	},
	methods:{
		/* public  设置组件的选中状态, 不需要调用响应事件 */
		setChecked: function( flag ){
			let hook=this.$refs["idChkHook"];
			if( flag )
			{
				this.$refs["idChkHide"].checked = true;
				this.myChecked = true;
				hook.innerText = "√";
				this.myVal = this.val;
				this.$emit("input", this.myVal );
			}
			else
			{
				this.$refs["idChkHide"].checked = false;
				this.myChecked = false;
				hook.innerText = "";
				this.myVal = "";
				this.$emit("input", "");
			}
		},
		/* public  将组件设置为禁用状态 */
		setDisabled: function( flag ){
			if( flag )
			{
				this.$refs["idChkBdr"].style["border"] = "1px solid #b4b4b4";
				this.$refs["idChkHook"].style["color"] = "#b4b4b4";
				this.myBdrClr = "#b4b4b4";
				this.$refs["idChkCapt"].style["color"] = "#b4b4b4";
				this.myDisabled = true;
			}
			else
			{
				this.myBdrClr = "#4a4a4a";
				this.$refs["idChkCapt"].style["color"] = "#4a4a4a";
				this.$refs["idChkBdr"].style["border"] = "1px solid "+this.myBdrClr;
				this.$refs["idChkHook"].style["color"] = this.myHookClr;
				this.myDisabled = false;
			}
		},
		/* private  点击响应事件 */
		onCheckClick: function(){
			if( this.myDisabled ) return;   //禁用模式下, 不响应

			//处理选中状态
			let hook=this.$refs["idChkHook"];
			if( this.myChecked )
			{
				this.$refs["idChkHide"].checked = false;
				this.myChecked = false;
				hook.innerText = "";
				this.myVal = "";
				this.$emit("input", "");
				if( this.myClick ) this.myClick( this.myVal, this.val );
			}
			else
			{
				this.$refs["idChkHide"].checked = true;
				this.myChecked = true;
				hook.innerText = "√";
				this.myVal = this.val;
				this.$emit("input", this.myVal );
				if( this.myClick ) this.myClick( this.myVal, "" );
			}
		},
	}
}

</script>

<style scoped>

#idCheckPanel{ flex:0 0 auto; position:relative; display:flex; flex-direction:row; align-items:center; border:0px solid red; }
#idChkBdr{ float:left; margin-left:1px; margin-top:1px; border-radius:3px; border:1px solid #4a4a4a; cursor:pointer; }
#idChkHook{ flex:0 0 auto; text-align:center; font-weight:bold; border:0px solid red; -moz-user-select: none; -webkit-user-select: none; -ms-user-select: none; -khtml-user-select: none; user-select: none; }
#idChkCapt{ flex:0 0 auto; text-align:center; text-indent:4px; border:0px solid red; margin-top:-1px; padding-right:4px; }

</style>



// WEBPACK FOOTER //
// cck.vue?30ed2af2